import gql from "graphql-tag";

export const getParticipants = gql`
    query GetParticipantsByType($id: ID!, $participantType: ParticipantTypeEnum!, $participantIdentityStatus: ParticipantIdentityStatusEnum) {
        participantsByType(id: $id, participantType: $participantType, participantIdentityStatus: $participantIdentityStatus) {
           participantID,
           name
        }
    }
`;
